import { Alert } from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PageContainer } from '@/shared/ui';

export const NotFoundPage: FC = () => {
  const { t } = useTranslation('common');

  return (
    <PageContainer>
      <Alert title={t('pageNotFound')} />
    </PageContainer>
  );
};
